<!-- begin:: Header Topbar -->
<div class="kt-header__topbar">
	<div *ngIf="!isProduction() && (isRedHost() || isBlueHost())" class="col-12" [ngClass]="{ 'custom-space-red': isRedHost(), 'custom-space-blue': isBlueHost() }">
		{{ restorationDate }}
	</div>
    <!--begin: Notifications -->
    <kt-notification *ngIf="!isMobile" class="notification"
		[bgImage]="'./assets/media/misc/bg-1.jpg'"
		[pulse]="true"
		[skin]="'dark'"
		[icon]="'./assets/media/icons/svg/General/Notifications1.svg'"
		[useSVG]="true">
	</kt-notification>
    <!--end: Notifications -->
	<!--begin: User bar -->
	<kt-user-profile [badge]="true" class="user-profile"></kt-user-profile>
	<!--end: User bar -->
</div>
<!-- end:: Header Topbar -->
